import { render, staticRenderFns } from "./PreviewMenu.vue?vue&type=template&id=3762cb27&scoped=true&"
import script from "./PreviewMenu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PreviewMenu.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PreviewMenu.vue?vue&type=style&index=0&id=3762cb27&lang=scss&scoped=true&"
import style1 from "./PreviewMenu.vue?vue&type=style&index=1&id=3762cb27&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762cb27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3762cb27')) {
      api.createRecord('3762cb27', component.options)
    } else {
      api.reload('3762cb27', component.options)
    }
    module.hot.accept("./PreviewMenu.vue?vue&type=template&id=3762cb27&scoped=true&", function () {
      api.rerender('3762cb27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/PreviewMenu/PreviewMenu.vue"
export default component.exports